export function openUmeRedirectTab(tabName = 'ume-redirect', options = {}) {
  const { title, heading, message } = options || {};
  // Open (or reuse) a named blank tab and render inline HTML
  const tab = window.open('', tabName);
  try {
    const doc = tab?.document;
    if (doc) {
      doc.open();
      doc.write(getUmeRedirectHtml({ title, heading, message }));
      doc.close();
    }
  } catch (e) {
    // Non-fatal: some browsers may restrict cross-window document access intermittently
    console.warn('Could not render redirect page', e);
  }
  return tab;
}

function getUmeRedirectHtml({
  title = 'Creating UnderwriteMe analysis…',
  heading = 'Creating the UnderwriteMe analysis',
  message = 'Please wait, we’ll redirect you shortly…',
} = {}) {
  return `<!doctype html>
    <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>${escapeHtml(title)}</title>
      <style>
        body { margin: 0; font-family: 'Inter', Arial, sans-serif; background: #f5f6fa; color: #323A46; }
        .header { background: #0F136F; height: 80px; display: flex; align-items: center; padding-left: 40px; box-sizing: border-box; }
        .logo { height: 36px; }
        .main { display: flex; align-items: center; justify-content: center; min-height: calc(100vh - 80px); background: #fff; }
        .box { text-align: center; padding: 24px 40px; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,.06); background: #fff; }
        .spinner { width: 30px; height: 30px; border: 3px solid #e5e7eb; border-top-color: #1E228C; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 12px; }
        @keyframes spin { to { transform: rotate(360deg); } }
        h1 { font-size: 18px; margin: 6px 0 4px; }
        p { margin: 0; font-size: 14px; color: #4B5768; }
      </style>
      <link rel="icon" href="/favicon.ico" />
      <link rel="icon" type="image/svg+xml" href="/Images/PGProBlue.svg" />
      <meta name="robots" content="noindex, nofollow" />
      <meta name="color-scheme" content="light" />
      <meta name="theme-color" content="#0F136F" />
    </head>
    <body>
      <header class="header"><img class="logo" src="/Images/PGProBlue.svg" alt="PGPro logo"></header>
      <div class="main">
        <div class="box">
          <div class="spinner"></div>
          <h1>${escapeHtml(heading)}</h1>
          <p>${escapeHtml(message)}</p>
        </div>
      </div>
    </body>
    </html>`;
}

function escapeHtml(input) {
  const s = String(input);
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
